import { INITIALIZE } from "../Actions/ActionTypes";
export var initialState = {
  preferencesProgressLoaded: false,
  preferencesCompletedOnLoad: false
};
var PreferencesReducer = function PreferencesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case INITIALIZE:
      {
        var _value$Preferences;
        var value = action.payload;
        return (_value$Preferences = value === null || value === void 0 ? void 0 : value.Preferences) !== null && _value$Preferences !== void 0 ? _value$Preferences : initialState;
      }
    default:
      return state;
  }
};
export default PreferencesReducer;